import { Button, StatusPage, t, Text } from '@kanbios/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiFailure } from '../lib/api';
import { useSignOut } from '../lib/session';

/**
 * Page-level refusal or failure (états transverses). The sentence and the
 * remedy come from the backend; a refusal never disguises itself as another.
 */
export function RefusalPage({ error }: { error: unknown }) {
  const navigate = useNavigate();
  const signOut = useSignOut();
  const failure = error instanceof ApiFailure ? error : null;
  const status = failure?.status === 404 ? '404' : failure?.status === 403 ? '403' : '500';
  // Signed in with an account that has no role: the only way out is another account.
  const noRole = failure?.body.code === 'FORBIDDEN_ROLE' && failure.body.details?.reason === 'no_role';
  useEffect(() => {
    // A 500 page must leave a trace for whoever investigates.
    if (status !== '500') return;
    if (failure?.beforeBackend) console.error(`HTTP ${failure.status} on ${failure.url}: no answer from the backend (dev: make logs s=web shows the proxy error)`);
    else console.error(failure ? `HTTP ${failure.status} on ${failure.url} (request ${failure.body.requestId}): ${failure.body.message}` : error);
  }, [status, failure, error]);
  return (
    <StatusPage
      status={status}
      title={failure?.body.message || undefined}
      // The DSM prints « Référence : » itself.
      reference={failure?.body.requestId || undefined}
      actions={
        status === '500'
          ? <Button variant="primary" onClick={() => window.location.reload()}>{t('errors.retry')}</Button>
          : noRole
          ? <Button variant="primary" onClick={() => void signOut()}>{t('errors.switchAccount')}</Button>
          : <Button variant="primary" onClick={() => navigate('/')}>{t('errors.backToDashboard')}</Button>
      }
    >
      {failure?.body.hint ? <Text variant="body">{failure.body.hint}</Text> : null}
    </StatusPage>
  );
}
